import * as React from "react";
import { LOBState } from "src/stores/wizard/state";
import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { CobrandImage } from "components/shared/CobrandImage/CobrandImage";
import { GlobalConfig } from "stores/wizard/config";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export interface SubmitButtonProps {
  lobState: LOBState;
  colSpan?: UitkLayoutConditionalGridSpan;
  className?: string;
  rfrr?: string;
  uisPrimeMicroMessages?: object[];
  subText?: string;
  globalConfig?: GlobalConfig;
}

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({
  colSpan,
  lobState,
  className,
  rfrr,
  uisPrimeMicroMessages,
  subText,
  globalConfig,
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan={colSpan} className={className ? className : ""}>
      <div>
        <ButtonTracked
          data-testid="submit-button"
          tag="button"
          type="submit"
          text={formatText(lobState.config.form.submitButton.locToken)}
          size={UitkButtonSize.LARGE}
          isFullWidth={true}
          moduleName={`StorefrontWizard`}
          rfrr={rfrr || `SearchClick_NA`}
          uisPrimeMicroMessages={uisPrimeMicroMessages}
          subText={subText}
        />
        <CobrandImage globalConfig={globalConfig} />
      </div>
    </UitkLayoutGridItem>
  );
};
